import styled from 'styled-components/macro';
import { Modal } from 'ui-component-library/components';
import { FlexAlignCenter, FlexAlignRight, FlexJustifyCenter } from '../../../../../shared-styles/flex';

export const StyledEmailModal = styled(Modal)`
`;

export const Container = styled.div`
`;

export const TextFieldContainer = styled.div`
  margin-bottom: ${(props) => props.theme.spacing(15)};
`;

export const TextFieldHeaderDiv = styled.div`
  ${FlexAlignCenter}
  justify-content: space-between;
  color: ${(props) => props.theme.palette.darkBlue[100]};
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
`;

export const CustomTextFieldLabel = styled.div`
  font-size: ${(props) => props.theme.typography.sizes.small};
  line-height: 19px;
  margin-bottom: 0;
  padding-left: ${(props) => props.theme.spacing(5)};
`;

export const TextFieldHelpText = styled.div`
  font-size: ${(props) => props.theme.typography.sizes.base};
  line-height: 14px;
  cursor: pointer;
`;

export const SubjectText = styled.div`
  font-family: ${({ theme }) => theme.typography.fonts.default};
  font-size: 12px;
  color: ${(props) => props.theme.palette.black[100]};
  width: 100%;
  padding: ${(props) => props.theme.spacing(5)} 0px ${(props) => props.theme.spacing(5)} ${(props) => props.theme.spacing(5)};
  box-sizing: border-box;
`;

export const TextAreaContainer = styled.div`
  margin-bottom: ${(props) => props.theme.spacing(5)};
`;

export const EmailBody = styled.div`
  font-family: ${({ theme }) => theme.typography.fonts.default};
  font-size: 12px;
  box-sizing: border-box;
  width: 100%;
  height: ${({ textAreaHeight }) => textAreaHeight};
  resize: none;
  outline: none;
  margin-top: 8px;
  white-space: pre-wrap;
  padding-left: ${(props) => props.theme.spacing(5)};
  overflow-y: auto;
`;

export const ButtonWrapper = styled.div`
  height: 40px;
  margin-top: ${(props) => props.theme.spacing(10)};
  ${FlexAlignRight}
  button:not(:first-child) {
    margin-left: ${(props) => props.theme.spacing(15)};
  }
`;

export const ErrorMessage = styled.div`
  color: ${(props) => props.theme.palette.red[100]};
  font-size: ${(props) => props.theme.typography.sizes.base};
  margin-bottom: ${(props) => props.theme.spacing(10)};
`;

export const SpinnerContainer = styled.div`
  ${FlexJustifyCenter}
  height: 695px;
`;

export const DisabledEmailField = styled.div`
  font-size: 12px;
  padding-left: ${(props) => props.theme.spacing(5)};
  padding-top: ${(props) => props.theme.spacing(5)};
`;

export const ContentContainer = styled.div`
  width: 500px;
`;
